
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/skipasy",
      function () {
        return require("private-next-pages/[region]/skipasy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/skipasy"])
      });
    }
  